module.exports = __webpack_public_path__ + "img/blurBg1.02f472ab.jpg";